import { 
    useTheme, 
    Box, 
    Typography, 
    Paper, 
    Chip, 
    IconButton, 
    Tooltip 
} from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { LAYOUT_HEIGHT } from 'state/constants';
import FlexCenter from 'components/FlexCenter';


const StatCell = ({ label, value }) => (
    <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography 
            variant="body2" 
            color="text.secondary" 
            textAlign="center"
        >
            {label}
        </Typography>
        <Typography 
            variant="body2" 
            textAlign="center"
        >
            {value}
        </Typography>
    </Box>
);

const OTPCard = ({ row, index, canView, onViewClick }) => {
    const theme = useTheme();
    return (
        <Paper 
            elevation={1} 
            sx={{ 
                p: 1.5, 
                borderLeft: `2px solid ${theme.palette.primary.main}`, 
                borderRadius: 1 
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ whiteSpace: 'nowrap' }}
                >
                    #{index + 1}
                </Typography>
                <Typography
                    variant="body2"
                    noWrap
                    flex={1}
                    minWidth={0}
                    sx={{ color: row.gender === 'FM' ? theme.palette.secondary.main : theme.palette.primary.dark }}
                >
                    {row.crewCode} {row.crewName}
                </Typography>
                {canView && (
                    <Tooltip title="View roster">
                        <IconButton
                            size="small"
                            onClick={() => onViewClick(row)}
                            sx={{ color: theme.palette.primary.dark, '&:hover': { color: theme.palette.green?.deep } }}
                        >
                            <Visibility fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>

            <Box display="flex" gap={0.5} mt={0.75} flexWrap="wrap">
                {row.post && (
                    <Chip 
                        variant="outlined" 
                        size="small" 
                        color="primary" 
                        label={row.post} 
                        sx={{ height: 20, fontSize: '0.7rem' }} 
                    />
                )}
                {row.base && (
                    <Chip 
                        variant="outlined" 
                        label={row.base} 
                        size="small" 
                        sx={{ height: 20, fontSize: '0.7rem' }} 
                    />
                )}
                {row.trainingQuals?.map(q => (
                    <Chip 
                        variant="outlined" 
                        size="small" 
                        key={q} 
                        label={q} 
                        color="warning" 
                        sx={{ height: 20, fontSize: '0.7rem' }} 
                    />
                ))}
            </Box>

            <Box display="grid" gridTemplateColumns="repeat(5, 1fr)" gap={1} mt={1}>
                <StatCell label="Sectors" value={row.sectors ?? 0} />
                <StatCell label="DepDelay" value={row.depDelayedSectors ?? 0} />
                <StatCell label="ArrDelay" value={row.arrDelayedSectors ?? 0} />
                <StatCell label="DepOTP" value={row.depOtp > 0 ? `${parseFloat(row.depOtp).toFixed(0)}%` : '0%'} />
                <StatCell label="ArrOTP" value={row.arrOtp > 0 ? `${parseFloat(row.arrOtp).toFixed(0)}%` : '0%'} />                
            </Box>
        </Paper>
    );
};


const OTPByCrewList = ({ rows, canView, onViewClick }) => {
    if (!rows?.length) {
        return (
            <FlexCenter height={LAYOUT_HEIGHT}>
                <Typography color="error">No data available</Typography>
            </FlexCenter>
        );
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            width="100%"
            gap={2}
        >
            {rows.map((row, index) => (
                <OTPCard key={row._id} row={row} index={index} canView={canView} onViewClick={onViewClick} />
            ))}
        </Box>
    );
};

export default OTPByCrewList;
